<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screen.screenTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" persistent>
          <!-- 編集ダイアログ -->
          <v-card>
            <v-card-title>
              <span class="headline">住民情報の編集</span>
            </v-card-title>
            <v-card-text>
              <v-form>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.name_kanji"
                        label="氏名"
                        :placeholder="config.PLACEHOLDER_NAME"
                        counter="64"
                        maxlength="64"
                        outlined
                        clearable
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.name_kana"
                        label="氏名カナ"
                        :placeholder="config.PLACEHOLDER_KANA_NAME"
                        counter="64"
                        maxlength="64"
                        outlined
                        clearable
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.birthday"
                        :rules="[rules.numberCheck, rules.rangeBirthdayCheck]"
                        label="生年月日"
                        :placeholder="config.PLACEHOLDER_BIRTH_YYYYMMDD"
                        counter="8"
                        maxlength="8"
                        outlined
                        clearable
                        @input="validation"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="editedItem.sex"
                        label="性別"
                        :placeholder="config.PLACEHOLDER_SELECT"
                        :items="selectList[2]"
                        item-value="status_id"
                        item-text="status_text"
                        outlined
                        clearable
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.postal_code"
                        :rules="[rules.numberCheck, rules.rangePostalNumCheck]"
                        label="郵便番号"
                        :placeholder="config.PLACEHOLDER_POST_NUMBER"
                        counter="7"
                        maxlength="7"
                        outlined
                        clearable
                        @input="validation"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        v-model="editedItem.address"
                        label="現住所"
                        :placeholder="config.PLACEHOLDER_ADDRESS"
                        counter="128"
                        maxlength="128"
                        outlined
                        clearable
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.eva_area_name"
                        label="避難元地区"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        counter="40"
                        maxlength="40"
                        outlined
                        clearable
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="editedItem.pregnancy_flg"
                        label="妊娠有無"
                        :placeholder="config.PLACEHOLDER_SELECT"
                        :items="selectList[0]"
                        item-value="status_id"
                        item-text="status_text"
                        outlined
                        clearable
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.vul_reason"
                        label="要配慮の理由"
                        :placeholder="config.PLACEHOLDER_VUL_REASON"
                        counter="30"
                        maxlength="30"
                        outlined
                        clearable
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="editedItem.lodine_tablets_take_status"
                        label="安定ヨウ素剤服用状況"
                        :placeholder="config.PLACEHOLDER_SELECT"
                        :items="selectList[0]"
                        item-value="status_id"
                        item-text="status_text"
                        outlined
                        clearable
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="editedItem.lodine_tablets_take_flg"
                        label="安定ヨウ素剤服用可否"
                        :placeholder="config.PLACEHOLDER_SELECT"
                        :items="selectList[1]"
                        item-value="status_id"
                        item-text="status_text"
                        outlined
                        clearable
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="editedItem.lodine_tablets_status"
                        label="安定ヨウ素剤所持状況"
                        :placeholder="config.PLACEHOLDER_SELECT"
                        :items="selectList[0]"
                        item-value="status_id"
                        item-text="status_text"
                        outlined
                        clearable
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.lodine_tablets_distribution"
                        :rules="[rules.numberCheck]"
                        label="安定ヨウ素剤配布番号"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        counter="12"
                        maxlength="12"
                        outlined
                        clearable
                        @input="validation"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.remarks"
                        label="備考"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        counter="100"
                        maxlength="100"
                        outlined
                        clearable
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mx-2"
                color="primary"
                :disabled="updateFlag"
                @click="save"
                >更新</v-btn
              >
              <v-btn class="mx-2" color="primary" @click="dialog = false">
                キャンセル
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <!-- 仮QRコード発行対象一覧画面 (検索部分)-->
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0">
          住民情報は下の表を参照してください。条件を指定することで一覧から絞り込むことができます。
        </p>
        <temporary-qr-code-issue-guide />
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              label="氏名"
              v-model="filterValues.name"
              :placeholder="config.PLACEHOLDER_NAME"
              clearable
              outlined
              append-icon="mdi-magnify"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              label="氏名カナ"
              v-model="filterValues.kanaName"
              :placeholder="config.PLACEHOLDER_KANA_NAME"
              clearable
              outlined
              append-icon="mdi-magnify"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
              label="性別"
              v-model="filterValues.sex"
              :placeholder="config.PLACEHOLDER_SELECT"
              :items="selectList[2]"
              item-value="status_id"
              item-text="status_text"
              clearable
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              label="生年月日"
              v-model="filterValues.birthDay"
              :placeholder="config.PLACEHOLDER_BIRTH"
              clearable
              outlined
              append-icon="mdi-magnify"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              label="郵便番号"
              v-model="filterValues.postNum"
              :placeholder="config.PLACEHOLDER_POST_NUMBER"
              clearable
              outlined
              append-icon="mdi-magnify"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              label="現住所"
              v-model="filterValues.address"
              :placeholder="config.PLACEHOLDER_ADDRESS"
              clearable
              outlined
              append-icon="mdi-magnify"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="10">
            <v-text-field
              label="避難元地区"
              v-model="filterValues.evaArea"
              :placeholder="config.PLACEHOLDER_INPUT"
              clearable
              outlined
              append-icon="mdi-magnify"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="10">
            <v-text-field
              label="要配慮の理由"
              v-model="filterValues.vulReason"
              :placeholder="config.PLACEHOLDER_VUL_REASON"
              clearable
              outlined
              append-icon="mdi-magnify"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="2">
            <v-select
              label="安定ヨウ素剤服用状況"
              v-model="filterValues.tabletsTakeStatus"
              :placeholder="config.PLACEHOLDER_SELECT"
              :items="selectList[0]"
              item-value="status_id"
              item-text="status_text"
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
              label="安定ヨウ素剤服用可否"
              v-model="filterValues.tabletsTakeFlg"
              :placeholder="config.PLACEHOLDER_SELECT"
              :items="selectList[1]"
              item-value="status_id"
              item-text="status_text"
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
              label="安定ヨウ素剤所持状況"
              v-model="filterValues.tabletsStatus"
              :placeholder="config.PLACEHOLDER_SELECT"
              :items="selectList[0]"
              item-value="status_id"
              item-text="status_text"
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
              label="妊娠の有無"
              v-model="filterValues.pregnancy"
              :placeholder="config.PLACEHOLDER_SELECT"
              :items="selectList[0]"
              item-value="status_id"
              item-text="status_text"
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              label="安定ヨウ素剤配布番号"
              v-model="filterValues.tabletsDist"
              :placeholder="config.PLACEHOLDER_INPUT"
              clearable
              outlined
              append-icon="mdi-magnify"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="10">
            <v-text-field
              label="備考"
              v-model="filterValues.remark"
              :placeholder="config.PLACEHOLDER_INPUT"
              clearable
              outlined
              append-icon="mdi-magnify"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-select
              v-model="filterValues.issueDate"
              :items="[...issueDates]"
              label="発行日"
              item-text="formatted_issue_date"
              item-value="issue_date"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
      <confirm-dialog ref="confirmDelete"></confirm-dialog>
      <!-- 仮QRコード発行対象一覧画面 (一覧部分) -->
      <v-divider class="mb-1"></v-divider>
      <top-operation-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :sort-by="sort.by"
        item-key="qrdisp_id"
        locale="ja-jp"
        loading-text="読込中"
        no-data-text="データがありません。"
        show-select
        must-sort
        class="fixedWidth"
        disp-mode="nowrap"
      >
        <template v-slot:[`item.birthday`]="{ item }">
          {{ formatBirthDay(item.birthday) }}
        </template>
        <template v-slot:[`item.sex`]="{ item }">
          {{ changeFormat("sex", item.sex) }}
        </template>
        <template v-slot:[`item.pregnancy_flg`]="{ item }">
          {{ changeFormat("pregnancy_flg", item.pregnancy_flg) }}
        </template>
        <template v-slot:[`item.lodine_tablets_take_status`]="{ item }">
          {{
            changeFormat(
              "lodine_tablets_take_status",
              item.lodine_tablets_take_status
            )
          }}
        </template>
        <template v-slot:[`item.lodine_tablets_take_flg`]="{ item }">
          {{
            changeFormat(
              "lodine_tablets_take_flg",
              item.lodine_tablets_take_flg
            )
          }}
        </template>
        <template v-slot:[`item.lodine_tablets_status`]="{ item }">
          {{
            changeFormat("lodine_tablets_status", item.lodine_tablets_status)
          }}
        </template>
        <template v-slot:[`item.name_kanji`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="text-truncate d-inline-block"
                style="max-width: 720px"
              >
                {{ item.name_kanji }}
              </span>
            </template>
            <span> {{ item.name_kanji }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.name_kana`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="text-truncate d-inline-block"
                style="max-width: 720px"
              >
                {{ item.name_kana }}
              </span>
            </template>
            <span> {{ item.name_kana }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.address`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="text-truncate d-inline-block"
                style="max-width: 720px"
              >
                {{ item.address }}
              </span>
            </template>
            <span> {{ item.address }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.remarks`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="text-truncate d-inline-block"
                style="max-width: 720px"
              >
                {{ item.remarks }}
              </span>
            </template>
            <span> {{ item.remarks }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.issue_date`]="{ item }">
          {{ formatDate(item.issue_date) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            small
            class="mx-2"
            color="primary"
            @click="editItem(item)"
            :disabled="!hasUpdateAuthorityByItem(item)"
          >
            編集
          </v-btn>
          <v-btn
            small
            class="mx-2"
            color="primary"
            @click="deleteItem(item)"
            :disabled="
              !hasDeleteAuthorityByItem(item, !screen.hasDeleteAuthority)
            "
          >
            削除
          </v-btn>
        </template>
      </top-operation-data-table>
      <v-row>
        <v-col>
          <v-btn
            :disabled="selected.length == 0"
            class="mx-2"
            color="primary"
            @click="printTmpQrresidents"
            >印刷</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn class="mx-2" color="primary" @click="closePage">戻る</v-btn>
        </v-col>
      </v-row>
    </v-sheet>
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import ConfirmDialog from "@/components/ConfirmDialog";
import TemporaryQrCodeIssueGuide from "@/components/qr-code/TemporaryQrCodeIssueGuide";
import { ScreenId } from "@/js/value-objects/screen-id";
import { TmpQrresidentsTranslator } from "@/js/translators/tmpQrresidentsTranslator";
import { createTmpQrCodePdf } from "@/js/repository/pdf-creator/tmpQrCodePdfCreator";
import messageUtils from "@/mixins/message-utils";
import { ErrorTodoMessages } from "@/js/constants/error-messages";
import config from "@/js/const";

const tmpQrresidentsRepository = RepositoryFactory.get("tmpQrresidents");
export default {
  mixins: [messageUtils],
  components: {
    ConfirmDialog,
    TemporaryQrCodeIssueGuide,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },
  data: () => ({
    loading: false, // データテーブルのローディング表示用
    overlay: false, // オーバーレイ表示用
    dialog: false,
    updateFlag: false, //  ダイアログ（編集）更新ボタンの活性化フラグ
    selected: [], // 選択アイテム情報
    items: [], // データテーブル表示用
    /**
     * 編集中アイテム情報
     */
    editedItem: {
      tmpqr_id: null, // 仮QRコードID
      manage_grp_id: null, // 仮QRコード発行単位ID
      group_name: null, // 仮QRコード発行単位
      qrdisp_id: null, // QRコード表示ID
      name_kanji: null, // 氏名（漢字）
      name_kana: null, // 氏名（カナ）
      address: null, // 表示用住所
      remarks: null, // 備考
      issue_date: null, // 発行日
      hash: null, // ハッシュ値
      birthday: null, // 生年月日
      postal_code: null, // 郵便番号
      eva_area_name: null, // 避難元地域名
      sex: null, // 性別
      vul_reason: null, // 要配慮者理由
      pregnancy_flg: null, // 妊娠有無
      lodine_tablets_take_status: null, // 安定ヨウ素剤服用状況
      lodine_tablets_take_flg: null, // 安定ヨウ素剤服用可否
      lodine_tablets_status: null, // 安定ヨウ素剤所持有無
      lodine_tablets_distribution: null // 安定ヨウ素剤配布番号
    },
    /**
     * アイテムのベース情報（初期化用）
     */
    defaultItem: {
      tmpqr_id: null, // 仮QRコードID
      manage_grp_id: null, // 仮QRコード発行単位ID
      group_name: null, // 仮QRコード発行単位
      qrdisp_id: null, // QRコード表示ID
      name_kanji: null, // 氏名（漢字）
      name_kana: null, // 氏名（カナ）
      address: null, // 表示用住所
      remarks: null, // 備考
      issue_date: null, // 発行日
      hash: null, // ハッシュ値
      birthday: null, // 生年月日
      postal_code: null, // 郵便番号
      eva_area_name: null, // 避難元地域名
      sex: null, // 性別
      vul_reason: null, // 要配慮者理由
      pregnancy_flg: null, // 妊娠有無
      lodine_tablets_take_status: null, // 安定ヨウ素剤服用状況
      lodine_tablets_take_flg: null, // 安定ヨウ素剤服用可否
      lodine_tablets_status: null, // 安定ヨウ素剤所持有無
      lodine_tablets_distribution: null // 安定ヨウ素剤配布番号
    },
    issueDates: [], // 発行日プルダウンの選択肢
    group_id: "", // 発行単位ID,
    group_name: "", // 発行単位
    screen: null, // 画面情報
    config: config, // 共通プレースホルダ
    // プールダウンパラメータ
    selectList: cloneDeep(WHICH_CHOOSE), // セレクトボックスに使われる選択項目リスト
    // フィルター用のv-model
    filterValues: {
      name: "", // 氏名
      kanaName: "", // 氏名カナ
      sex: "", // 性別
      birthDay: "", // 生年月日
      postNum: "", // 郵便番号
      address: "", // 現住所
      evaArea: "", // 避難元地域名
      vulReason: "", // 要配慮者理由
      pregnancy: "", // 妊娠有無
      tabletsTakeStatus: "", // 安定ヨウ素剤服用状況
      tabletsTakeFlg: "", // 安定ヨウ素剤服用可否
      tabletsStatus: "", // 安定ヨウ素剤所持有無
      tabletsDist: "", // 安定ヨウ素剤配布番号
      remark: "", // 備考
      issueDate: "" // 発行日
    },
    // バリデーションチェック
    rules: {
      // 数字＆空白のみ許可するチェック
      numberCheck: value =>
        /^(|\d)+$/.test(value || "") || ErrorTodoMessages.ERWE40008,
      // 生年月日の桁数チェック
      rangeBirthdayCheck: value =>
        0 < (value || "").length && (value || "").length < 8
          ? ErrorTodoMessages.ERWE40016
          : true,
      // 郵便番号の桁数チェック
      rangePostalNumCheck: value =>
        0 < (value || "").length && (value || "").length < 7
          ? ErrorTodoMessages.ERWE40017
          : true
    }
  }),

  computed: {
    headers() {
      return [
        {
          text: "発行単位",
          value: "group_name",
          sortable: false
        },
        {
          text: "No",
          value: "qrdisp_id"
        },
        {
          text: "氏名",
          value: "name_kanji",
          filter: this.nameFilter
        },
        {
          text: "氏名カナ",
          value: "name_kana",
          filter: this.kanaNameFilter
        },
        {
          text: "生年月日",
          value: "birthday",
          filter: this.birthDayFilter,
          align: "center"
        },
        {
          text: "郵便番号",
          value: "postal_code",
          filter: this.postNumFilter,
          align: "center"
        },
        {
          text: "現住所",
          value: "address",
          filter: this.addressFilter
        },
        {
          text: "避難元地区",
          value: "eva_area_name",
          filter: this.evaAreaFilter,
          align: "center"
        },
        {
          text: "性別",
          value: "sex",
          filter: this.sexFilter,
          align: "center"
        },
        {
          text: "要配慮の理由",
          value: "vul_reason",
          filter: this.vulReasonFilter,
          align: "center"
        },
        {
          text: "妊娠有無",
          value: "pregnancy_flg",
          filter: this.pregnancyFilter,
          sort: this.emptyStringSorter,
          align: "center"
        },
        {
          text: "安定ヨウ素剤服用状況",
          value: "lodine_tablets_take_status",
          filter: this.tabletsTakeStatusFilter,
          sort: this.emptyStringSorter,
          align: "center"
        },
        {
          text: "安定ヨウ素剤服用可否",
          value: "lodine_tablets_take_flg",
          filter: this.tabletsTakeFlgFilter,
          sort: this.emptyStringSorter,
          align: "center"
        },
        {
          text: "安定ヨウ素剤所持状況",
          value: "lodine_tablets_status",
          filter: this.tabletsStatusFilter,
          sort: this.emptyStringSorter,
          align: "center"
        },
        {
          text: "安定ヨウ素剤\n配布番号",
          value: "lodine_tablets_distribution",
          filter: this.tabletsDistFilter,
          align: "center"
        },
        {
          text: "備考",
          value: "remarks",
          filter: this.remarkFilter
        },
        {
          text: "発行日",
          value: "issue_date",
          filter: this.issueDateFilter
        },
        {
          text: "操作",
          value: "actions",
          sortable: false
        }
      ];
    },
    sort() {
      /**
       * /一覧をソートした状態で一覧のチェックボックスにチェックを入れると
       * ソート状態が解除されるエラーに対応
       * */
      return {
        by: ["qrdisp_id"]
      };
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    $route: "initialize"
  },

  mounted() {
    this.pageTitle(this.screen.screenTitle);
  },

  created() {
    this.initialize();
  },

  methods: {
    /**
     * 初期化処理
     */
    async initialize() {
      this.overlay = true;
      this.loading = true;

      // 発行単位IDの設定
      this.group_id = this.$route.query.group_id;
      // 発行単位グループ名の設定
      this.group_name = this.$route.query.group_name;

      // 画面情報
      this.screen = this.$screenOperationAuthority(
        ScreenId.SF0609,
        ScreenId.SF0609
      );

      // 仮QRコード住民情報の取得
      const payload = {
        manage_grp_id: this.group_id
      };
      await tmpQrresidentsRepository
        .list(ScreenId.SF0609, payload)
        .then(response => {
          this.items = response.data.results;
          // アイテムに発行単位を追加
          this.items.forEach(item => {
            item.group_name = this.group_name;
          });
          // 発行日プルダウン候補設定
          this.items.forEach(item => {
            const ISSUE_DATE = {
              issue_date: item.issue_date,
              formatted_issue_date: this.$moment(
                item.issue_date,
                "YYYYMMDD"
              ).format("YYYY/MM/DD")
            };
            if (this.issueDates.indexOf(ISSUE_DATE) === -1) {
              this.issueDates.push(ISSUE_DATE);
            }
          });
          this.issueDates.sort();
        })
        .catch(e => {
          this.handleError(e, ScreenId.SF0609, "temporary-qr-code-group");
        });

      this.loading = false;
      this.overlay = false;
    },

    /**
     * 編集ボタン押下時処理
     */
    editItem(item) {
      this.editedItem = cloneDeep(item);
      this.dialog = true;
    },

    /**
     * 削除ボタン押下時処理
     */
    async deleteItem(item) {
      /* 削除確認ダイアログ表示 */
      let message = "QRコード情報を削除しますか？";
      if (!(await this.deleteConfirm(message))) {
        return;
      }
      message = "削除した場合には元に戻せません。本当によろしいですか？";
      if (!(await this.deleteConfirm(message))) {
        return;
      }
      /* 削除処理 */
      this.clearMessage();
      this.overlay = true;
      await tmpQrresidentsRepository
        .delete(ScreenId.SF0609, TmpQrresidentsTranslator.toDeletePayload(item))
        .then(response => {
          this.handleSuccess(response);
        })
        .catch(e => {
          this.handleUpdateError(e);
        })
        .finally(() => {
          this.overlay = false;
          this.initialize();
        });
    },

    /**
     * 削除確認ダイアログ表示
     */
    deleteConfirm(message) {
      return this.$refs.confirmDelete.open(message, "削除");
    },

    /**
     * 編集ダイアログ（クローズ処理）
     */
    close() {
      // 編集用アイテムの初期化
      this.editedItem = cloneDeep(this.defaultItem);
    },

    /**
     * 編集ダイアログ（更新ボタン）
     */
    async save() {
      /* 更新処理 */
      this.clearMessage();
      this.overlay = true;
      await tmpQrresidentsRepository
        .update(
          ScreenId.SF0609,
          TmpQrresidentsTranslator.toUpdatePayload(this.editedItem)
        )
        .then(response => {
          this.handleSuccess(response);
        })
        .catch(e => {
          this.handleUpdateError(e);
        })
        .finally(() => {
          this.dialog = false;
          this.overlay = false;
          this.initialize();
        });
    },

    /**
     * データテーブル表示用（発行日）
     */
    formatDate(date) {
      const formattedDate = this.$moment(date);
      if (formattedDate.isValid()) {
        return formattedDate.format("YYYY/MM/DD");
      }
      return "";
    },

    /**
     * データテーブル表示用（生年月日）
     */
    formatBirthDay(date) {
      const formattedDate = this.$moment(date);
      if (formattedDate.isValid()) {
        return formattedDate.format("YYYY年MM月DD日");
      }
      return "";
    },

    /**
     * テーブルのカラムのフォーマット変更
     */
    changeFormat(columnName, value) {
      switch (columnName) {
        // 妊娠有無
        case "pregnancy_flg":
          return value == "" ? "" : value == 0 ? "無" : "有";
        // 安定ヨウ素剤服用有無
        case "lodine_tablets_take_status":
          return value == "" ? "" : value == 0 ? "無" : "有";
        // 安定ヨウ素剤服用可否
        case "lodine_tablets_take_flg":
          return value == "" ? "" : value == 0 ? "否" : "可";
        // 安定ヨウ素剤所持状況
        case "lodine_tablets_status":
          return value == "" ? "" : value == 0 ? "無" : "有";
        // 性別
        case "sex":
          if (value == 1) {
            return "男";
          } else if (value == 2) {
            return "女";
          } else if (value == 3) {
            return "どちらでもない";
          } else {
            return "";
          }
      }
      return value;
    },

    /**
     * カスタムフィルター (氏名)
     */
    nameFilter(value) {
      if (!this.filterValues.name) {
        return true;
      }
      return value.includes(this.filterValues.name);
    },
    /**
     * カスタムフィルター (氏名カナ)
     */
    kanaNameFilter(value) {
      if (!this.filterValues.kanaName) {
        return true;
      }
      return value.includes(this.filterValues.kanaName);
    },
    /**
     * カスタムフィルター (性別)
     */
    sexFilter(value) {
      if (!this.filterValues.sex) {
        return true;
      }
      return value.includes(this.filterValues.sex);
    },
    /**
     * カスタムフィルター (生年月日)
     */
    birthDayFilter(value) {
      if (!this.filterValues.birthDay) {
        return true;
      }
      return value.includes(this.filterValues.birthDay.replace(/\//g, ""));
    },
    /**
     * カスタムフィルター (郵便番号)
     */
    postNumFilter(value) {
      if (!this.filterValues.postNum) {
        return true;
      }
      return value.includes(this.filterValues.postNum);
    },
    /**
     * カスタムフィルター (現住所)
     */
    addressFilter(value) {
      if (!this.filterValues.address) {
        return true;
      }
      return value.includes(this.filterValues.address);
    },
    /**
     * カスタムフィルター (避難元地域名)
     */
    evaAreaFilter(value) {
      if (!this.filterValues.evaArea) {
        return true;
      }
      return value.includes(this.filterValues.evaArea);
    },
    /**
     * カスタムフィルター (要配慮者理由)
     */
    vulReasonFilter(value) {
      if (!this.filterValues.vulReason) {
        return true;
      }
      return value.includes(this.filterValues.vulReason);
    },
    /**
     * カスタムフィルター (妊娠有無)
     */
    pregnancyFilter(value) {
      if (!this.filterValues.pregnancy) {
        return true;
      }
      return value.includes(this.filterValues.pregnancy);
    },
    /**
     * カスタムフィルター (安定ヨウ素剤服用状況)
     */
    tabletsTakeStatusFilter(value) {
      if (!this.filterValues.tabletsTakeStatus) {
        return true;
      }
      return value.includes(this.filterValues.tabletsTakeStatus);
    },
    /**
     * カスタムフィルター (安定ヨウ素剤服用可否)
     */
    tabletsTakeFlgFilter(value) {
      if (!this.filterValues.tabletsTakeFlg) {
        return true;
      }
      return value.includes(this.filterValues.tabletsTakeFlg);
    },
    /**
     * カスタムフィルター (安定ヨウ素剤所持有無)
     */
    tabletsStatusFilter(value) {
      if (!this.filterValues.tabletsStatus) {
        return true;
      }
      return value.includes(this.filterValues.tabletsStatus);
    },
    /**
     * カスタムフィルター (安定ヨウ素剤配布番号)
     */
    tabletsDistFilter(value) {
      if (!this.filterValues.tabletsDist) {
        return true;
      }
      return value.includes(this.filterValues.tabletsDist);
    },
    /**
     * カスタムフィルター (備考)
     */
    remarkFilter(value) {
      if (!this.filterValues.remark) {
        return true;
      }
      return value.includes(this.filterValues.remark);
    },
    /**
     * カスタムフィルター（発行日）
     */
    issueDateFilter(value) {
      if (!this.filterValues.issueDate) {
        return true;
      }
      return value === this.filterValues.issueDate;
    },

    /**
     * 戻るボタン押下時処理
     */
    closePage() {
      this.$router.push({
        path: `/temporary-qr-code`
      });
    },

    /**
     * 印刷ボタン押下時処理
     */
    async printTmpQrresidents() {
      /* PDF生成 */
      // Noの昇順でソート
      let tmpQrresidents = this.selected.sort(
        (a, b) => a.qrdisp_id - b.qrdisp_id
      );
      // PDF作成
      createTmpQrCodePdf(tmpQrresidents, this.group_id, this.group_name);
    },

    /**
     * 更新ボタン活性化制御
     */
    validation() {
      const BIRTHDAY = this.editedItem.birthday || ""; // ""はnull,undefiend防止のため
      const POSTAL_CODE = this.editedItem.postal_code || "";
      const LODINE_TABLETS_DISTRIBUTION =
        this.editedItem.lodine_tablets_distribution || "";

      // 属性チェック
      const CHECK_STR = BIRTHDAY + POSTAL_CODE + LODINE_TABLETS_DISTRIBUTION;
      const IS_NUMBER = !!String(CHECK_STR).match(/^(|\d)+$/);
      // 桁数チェック
      const IS_NOT_BIRTH_RANGE = !(0 < BIRTHDAY.length && BIRTHDAY.length < 8);
      const IS_NOT_POSTAL_RANGE = !(
        0 < POSTAL_CODE.length && POSTAL_CODE.length < 7
      );

      // 属性、桁数のチェック結果が問題なければ更新ボタン活性化
      this.updateFlag =
        IS_NUMBER && IS_NOT_BIRTH_RANGE && IS_NOT_POSTAL_RANGE ? false : true;
    },
    /**
     * カスタムソーター
     * 空白を含むセルが存在する時、セルのソーター結果に異常があるため作成
     * ヘッダーの昇順降順選択によってa,bの値が変わる
     */
    emptyStringSorter(a, b) {
      if (a !== b) {
        const sortList = ["", "1", "0"];
        const indexA = sortList.indexOf(a);
        const indexB = sortList.indexOf(b);
        // sortListによる昇順・降順切り分け
        if (indexA > indexB) {
          return 1;
        } else {
          return -1;
        }
      }
      return 0;
    }
  }
};

/**
 * セレクトボックスに使われる選択項目リスト
 */
const WHICH_CHOOSE = Object.freeze([
  // 妊娠有無・安定ヨウ素剤服用状況・安定ヨウ素剤所持状況
  [
    {
      status_id: "0",
      status_text: "無"
    },
    {
      status_id: "1",
      status_text: "有"
    }
  ],
  // 安定ヨウ素剤服用可否
  [
    {
      status_id: "1",
      status_text: "可"
    },
    {
      status_id: "0",
      status_text: "否"
    }
  ],
  // 性別
  [
    {
      status_id: "1",
      status_text: "男"
    },
    {
      status_id: "2",
      status_text: "女"
    },
    {
      status_id: "3",
      status_text: "どちらでもない"
    }
  ]
]);
</script>
